import React from 'react';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { SiLeetcode } from "react-icons/si";

const HeaderSocials = () => {
  return (
    <div className="header__socials">
      <a href="https://www.linkedin.com/in/laraib-khan-a2992624b/" target="_blank" rel="noreferrer" ><BsLinkedin /></a>
      <a href="https://github.com/Laraibkhan13" target="_blank" rel="noreferrer" ><FaGithub /></a>
      <a href="https://leetcode.com/u/laraib_13/" target="_blank" rel="noreferrer" ><SiLeetcode/></a>
    </div>
  )
}

export default HeaderSocials